import toastr from 'toastr';
window.toastr = toastr;
